<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="false"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
    ></search-form>
    <a-modal
      width="800px"
      v-model:open="open"
      :title="pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model no-pdModal"
    >
      <action
        :v-if="open"
        :editData="editData"
        :data="tableData"
        :idField="idField"
      ></action>
      <approval_process_content :data="approvalProcessData">
      </approval_process_content>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'type_id'">
          {{ codeToText(record?.type_id, Enum.carModel.value) }}
        </template>
        <template v-if="column.key === 'type'">
          {{ codeToText(record.type, Enum.blackWhiteListType.value) }}
        </template>
        <template v-if="column.key === 'time_range'">
          {{ record?.begin_time }} 至
          {{ record?.end_time }}
        </template>
        <template v-if="column.key === 'interviewee_depart_id'">
          {{ codeToText(record.interviewee_depart_id, Enum.dept.value) }}
        </template>
        <template v-if="column.key === 'visit_area'">
          {{ codeToText(record?.visit_area, Enum.areaType.value) }}
        </template>
        <template v-if="column.key === 'state'">
          {{ codeToText(record?.state, Enum.status.value) }}
        </template>
        <template v-if="column.key === 'create_user_id'">
          {{ codeToText(record.create_user_id, Enum.user.value) }}
        </template>
        <template v-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record"
            >
              详情
            </a-button>
            <a-button
              @click="showApprovalProcess(record)"
              :loading="loadingRecord === record[idField] + 'process'"
              v-if="record.state !== 0"
            >
              审批流程
            </a-button>
            <a-button
              @click="showRevokeModal(record)"
              v-if="ableRevoke && (record.state === 1 || record.state === 2)"
              :loading="loadingRecord === record[idField] + 'revoke'"
              danger
            >撤销审批</a-button>
          </span>
        </template>
      </template>
    </a-table>
    <approval_process
      v-model:openModal="approvalProcessOpen"
      :data="approvalProcessData"
    ></approval_process>
    <a-modal v-model:open="revokeModalOpen" title="是否撤销审批？">
      <a-form :model="revokeModalData" ref="revokeModalFormRef" :rules="revokeModalRules">
        <a-form-item label="撤销理由" name="reason">
          <a-textarea v-model:value="revokeModalData.reason" placeholder="请输入撤销理由" />
        </a-form-item>
      </a-form>
      <template #footer>
        <a-button @click="revokeModalOpen = false">取消</a-button>
        <a-button type="primary" @click="revokeRow">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute } from 'vue-router'
  import {
    getData,
    getDetail,
  } from '@/api/car_application/car_registration_history'
  import action from './action'
  import { message } from 'ant-design-vue'
  import searchForm from '@/components/search_form'
  import { codeToText, constantToOptions } from '@/utils/format'
  import approval_process from '@/components/approval_process'
  import approval_process_content from '@/components/approval_process_content'
  import { approvalProcess, revoke } from '@/api/car_application/car_registration'
  import { approvalOperation } from '@/utils/common'
  import dayjs from 'dayjs'
  //初始化
  const pageName = '车辆备案记录'
  const idField = 'id' //响应数据的id的字段名
  const store = useStore()
  const route = useRoute()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carRegistrationHistory:list')
  )
  const ableRevoke = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carRegistrationHistory:revoke')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'application_number',
      label: '受理单号',
    },
    {
      type: 'input',
      field: 'license_plate',
      label: '车牌号码',
    },
    {
      type: 'input',
      field: 'visitor_company',
      label: '来访单位',
    },
    {
      type: 'select',
      field: 'visit_area',
      storeOptions: 'areaType',
      defaultValue: 3,
      label: '备案园区',
      width: '160px',
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'status',
      storeOptions: 'status',
      defaultValue: -1,
      label: '审核状态',
      width: '130px',
    },
    {
      type: 'dateRange',
      startField: 'begin_time',
      endField: 'end_time',
      // defaultStart: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
      // defaultEnd: dayjs().add(30, 'day').format('YYYY-MM-DD'),
      label: '时间范围',
      'allow-clear': true,
    },
    {
      type: 'dateRange',
      startField: 'create_date_start',
      endField: 'create_date_end',
      label: '创建时间',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setCarRegHistory', params)
  }

  //2、表格
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      align: 'center',
      width: 50,
      fixed: 'left',
    },
    {
      title: '受理单号',
      dataIndex: 'application_number',
      key: 'application_number',
      align: 'left',
    },
    {
      title: '审核状态',
      dataIndex: 'state',
      key: 'state',
      align: 'left',
      width: 130,
    },
    {
      title: '园区类型',
      dataIndex: 'visit_area',
      key: 'visit_area',
      align: 'left',
    },
    {
      title: '来访单位',
      dataIndex: 'visitor_company',
      key: 'visitor_company',
      align: 'left',
      width: 180,
    },
    {
      title: '车牌颜色',
      dataIndex: 'license_plate_color',
      key: 'license_plate_color',
      align: 'left',
    },
    {
      title: '车牌号码',
      dataIndex: 'license_plate',
      key: 'license_plate',
      align: 'left',
    },
    {
      title: '备案时间范围',
      key: 'time_range',
      align: 'left',
    },
    {
      title: '撤销理由',
      dataIndex: 'revoke_reason',
      key: 'revoke_reason',
      align: 'left',
      width: 180,
    },
    {
      title: '提交人',
      dataIndex: 'user_name',
      key: 'user_name',
      align: 'left',
      dataInObject: 'createUser',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    /*
    {
      title: '修改时间',
      dataIndex: 'update_time',
      key: 'update_time',
      align: 'left',
    },*/
    {
      title: '提交审核时间',
      dataIndex: 'submit_time',
      key: 'submit_time',
      align: 'left',
    },
    {
      // title: '最后审核时间',
      title: '审核时间',
      dataIndex: 'approve_time',
      key: 'approve_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      // width: '120px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
      // 保存数据到store
      store.commit('search/setCarRegHistoryTableData', data.list)
      store.commit('search/setCarRegHistoryPagination', pagination.value)
    })
  }
  
  // 从store获取缓存的搜索参数、表格数据和分页信息
  const cachedSearchParams = computed(() => store.state.search.searchCarRegHistory)
  const cachedTableData = computed(() => store.state.search.carRegHistoryTableData)
  const cachedPagination = computed(() => store.state.search.carRegHistoryPagination)
  onMounted(() => {
    // 恢复搜索参数
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    
    // 如果是从标签页点击跳转过来的，从store恢复表格数据和分页信息
    if (route.query?.fromTabClick) {
      if (cachedTableData.value) {
        tableData.value = cachedTableData.value
      }
      if (cachedPagination.value) {
        pagination.value = cachedPagination.value
      }
      return
    }
    
    // 否则执行查询
    fetch()
  })

  //3、详情
  const open = ref(false)
  const isEdit = ref(true)
  const editData = ref(null)
  const showEditModal = async (data) => {
    loadingRecord.value = data
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      isEdit.value = true
      open.value = true
      approvalProcessData.value = []
      // 获取审批流程
      if (data.state !== 0 && data.state !== 4) {
        await getApprovalProcess(data[idField])
      }
    }
  }
  async function fetchDetail(id) {
    const res = await getDetail({ id })
    if (res.success) {
      return res.data
    } else {
      message.warn('获取详情失败')
    }
  }
  //4、审批流程
  const approvalProcessOpen = ref(false)
  const approvalProcessData = ref()
  async function getApprovalProcess(id) {
    const res = await approvalProcess({ id })
    approvalProcessData.value = res.data
  }
  async function showApprovalProcess(record) {
    loadingRecord.value = record[idField] + 'process'
    await getApprovalProcess(record[idField])
    approvalProcessOpen.value = true
    loadingRecord.value = null
  }
  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  const revokeModalFormRef = ref()
  const revokeModalRules = {
    reason: [
      { required: true, message: '请输入撤销理由', trigger: 'blur' }
    ]
  }
  const revokeModalOpen = ref(false)
  const revokeModalData = ref({
    reason: '',
    id: ''
  })
  function showRevokeModal(record) {
    revokeModalData.value = {
      reason: '',
      id: record[idField]
    }
    revokeModalOpen.value = true
  }
  async function revokeRow() {
    await revokeModalFormRef.value.validate()
    const { id, reason } = revokeModalData.value
    loadingRecord.value = id + 'revoke'
    try {
      const res = await revoke({ id, reason })
      if (res.success) {
        message.success('撤销审核成功！')
        fetch()
        revokeModalOpen.value = false
      } else {
        message.warn('撤销审核失败' + res.message)
      }
    } finally {
      loadingRecord.value = null
    }
  }
</script>
